import React from "react";

function Tshirt() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="44"
      height="44"
      fill="none"
      viewBox="0 0 44 44"
    >
      <g
        stroke="#13121A"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.75"
        clipPath="url(#clip0_226_703)"
      >
        <path d="M27.5 7.333L38.5 11v9.167H33v14.666a1.834 1.834 0 01-1.833 1.834H12.833A1.833 1.833 0 0111 34.833V20.167H5.5V11l11-3.667a5.5 5.5 0 0011 0z"></path>
        <path d="M19.25 20.167h4.583l-2.75 9.166"></path>
      </g>
      <defs>
        <clipPath id="clip0_226_703">
          <path fill="#fff" d="M0 0H44V44H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default Tshirt;
